import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import './Footer.css';
function Copyright() {
  const { t } = useTranslation('footer');
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {t('copyright', { year: new Date().getFullYear() })}
    </Typography>
  );
}
export default function Footer() {
  const { t } = useTranslation('footer');
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        {}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            borderTop: '1px solid',
            borderColor: 'divider',
            pt: 3,
          }}
        >
          <div>
            <Link color="text.secondary" variant="body2" href="/privacy-policy">
              {t('links.privacyPolicy')}
            </Link>
            <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
              &nbsp;•&nbsp;
            </Typography>
            <Link color="text.secondary" variant="body2" href="/terms-of-service">
              {t('links.termsOfService')}
            </Link>
            <Copyright />
          </div>
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ justifyContent: 'left', color: 'text.secondary' }}
          >
            <IconButton
              color="inherit"
              size="small"
              href="https://github.com/mui"
              aria-label={t('social.github')}
              sx={{ alignSelf: 'center' }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://x.com/MaterialUI"
              aria-label={t('social.twitter')}
              sx={{ alignSelf: 'center' }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://www.linkedin.com/company/mui/"
              aria-label={t('social.linkedin')}
              sx={{ alignSelf: 'center' }}
            >
              <LinkedInIcon />
            </IconButton>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
